export default ({ Schema }) => {
  const PointSchema = new Schema(
    {
      type: {
        type: String,
        enum: ['Point'],
        default: 'Point',
      },
      coordinates: {
        type: [Number],
        required: true,
      },
    },
    { _id: false }
  )

  return PointSchema
}
